import Field from "./Field";

class PasswordField extends Field {
    constructor(name) {
        super(name);
        this._type = "password";
    }
}

export default PasswordField;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/Field/PasswordField.js
 **/